export const COLORS = { BACKGROUND: "#1a1a1a", PRIMARY_GOLD: "#D1AA64", SECONDARY_GOLD: "#D1AA64", TEXT_WHITE: "#f5f5f5", TEXT_DIM: "#a9a9a9", CARD_DEFAULT: "#2e2e2e", CARD_SELECTED: "#D1AA64", CARD_HOVER: "#D1AA64", INPUT_BG: "#333333" }
